































import Vue from 'vue';
import { mapState, mapActions } from 'vuex';

export default Vue.extend({
    components: {},
    props: { links: { required: true, default: [] } },
    computed: {
        ...mapState(['drawer']),
        ...mapState(['drawerMini']),
        mini() {
            return this.$vuetify.breakpoint.smAndDown || this.drawerMini;
        },
    },
    methods: {
        ...mapActions(['toggleDrawerMini']),
    },
});
